import React, { useCallback, useEffect, useState } from "react";

import { Filter, RefreshCw } from "lucide-react";

import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";

import MISDashboardCards from "../../components/MISReportComponents/MISDashboardCards";
import LeadLeakageCard from "../../components/MISReportComponents/LeadLeakageCard";
import RevenueForecastCard from "../../components/MISReportComponents/RevenueForecastCard";
import PipelineStageAnalysisCard from "../../components/MISReportComponents/PipelineStageAnalysisCard";
import TopSalesPerformersCard from "../../components/MISReportComponents/TopSalesPerformersCard";
import FollowupPerformanceCard from "../../components/MISReportComponents/FollowupPerformanceCard";
import LeadAgingReportCard from "../../components/MISReportComponents/LeadAgingReportCard";
import PipelineDistributionCard from "../../components/MISReportComponents/PipelineDistributionCard";
import MonthlyLeadTrendCard from "../../components/MISReportComponents/MonthlyLeadTrendCard";
import IndustryAnalysisCard from "../../components/MISReportComponents/IndustryAnalysisCard";
import MISFilterDrawer from "../../components/MISFilterDrawer";

const defaultFilters = {
  filterType: "thisMonth",
  divisionId: "",
  userId: "",
  stageId: "",
  industryType: "",
  fromDate: "",
  toDate: "",
};

const MISReport = () => {
  const [loading, setLoading] = useState(true);

  const [showFilters, setShowFilters] = useState(false);

  const [dashboardData, setDashboardData] = useState(null);

  // Drawer state
  const [filters, setFilters] = useState(defaultFilters);

  // Applied state
  const [appliedFilters, setAppliedFilters] = useState(defaultFilters);

  const fetchDashboard = useCallback(async () => {
    try {
      setLoading(true);

      const params = new URLSearchParams();

      Object.entries(appliedFilters).forEach(([key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          params.append(key, value);
        }
      });

      const response = await api.get(
        `${SummaryApi.getMISDashboard.url}?${params.toString()}`,
      );

      if (response?.data?.success) {
        setDashboardData(response.data.data.cards);
      }
    } catch (error) {
      console.error("MIS Dashboard Error", error);
    } finally {
      setLoading(false);
    }
  }, [appliedFilters]);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  const handleApplyFilters = () => {
    setAppliedFilters(filters);

    setShowFilters(false);
  };

  const handleRefresh = () => {
    fetchDashboard();
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}

      <div className="bg-white border-b sticky top-0 z-20">
        <div className="px-4 md:px-6 py-4 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
              MIS Dashboard
            </h1>

            <p className="text-sm text-gray-500 mt-1">
              Business Intelligence & Performance Reports
            </p>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={handleRefresh}
              className="h-11 px-4 rounded-xl border bg-white hover:bg-gray-50 flex items-center gap-2"
            >
              <RefreshCw size={16} />
              Refresh
            </button>

            <button
              onClick={() => setShowFilters(true)}
              className="h-11 px-4 rounded-xl bg-red-600 hover:bg-red-700 text-white flex items-center gap-2"
            >
              <Filter size={16} />
              Filters
            </button>
          </div>
        </div>
      </div>

      {/* Content */}

      <div className="p-4 md:p-6 space-y-6">
        <MISDashboardCards data={dashboardData} loading={loading} />

        {/* Revenue Forecast */}

        <div>
          <RevenueForecastCard />
        </div>

        {/* Lead Leakage */}

        <div>
          <LeadLeakageCard />
        </div>

        {/* Sales Performance */}

        <div>
          <PipelineStageAnalysisCard />
        </div>
        
        <div>
          <TopSalesPerformersCard />
        </div>

        <div>
          <FollowupPerformanceCard />
        </div>
        
        <div>
          <LeadAgingReportCard />
        </div>
        
        <div>
          <PipelineDistributionCard />
        </div>
        
        <div>
          <MonthlyLeadTrendCard />
        </div>

        <div>
          <IndustryAnalysisCard />
        </div>

      </div>

      <MISFilterDrawer
        open={showFilters}
        onClose={() => setShowFilters(false)}
        filters={filters}
        setFilters={setFilters}
        onApply={handleApplyFilters}
      />
    </div>
  );
};

export default MISReport;
